
import UserBannersComponent from "../../../components/user_banners/Index.vue"

export default({
  components: {
    UserBannersComponent,
  }
})
